import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt-PT';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {
  AuthModule,
  AutomationTestsInterceptor,
  AutomationTestsService,
  AutomationsTestsLoader,
  provideUnavailableFeaturesInitializer,
} from '@eredes/auth';
import { RequestsConfigModule } from '@eredes/dfcore';
import { DSM34DialogModule, Dsm34LoaderModule } from '@eredes/dsm34';
import { MicroservicesModule } from '@eredes/microservices';
import { ScmModule } from '@eredes/scm';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RECAPTCHA_LANGUAGE, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { NgxLoadingModule } from 'ngx-loading';
import { NgPipesModule } from 'ngx-pipes';

import { AuthSessionModule } from './_core/auth-session/auth-session.module';
import { CoreModule } from './_core/core.module';
import { SharedModule } from './_shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Auth401Component } from './auth/401/401.component';
import { AuthComponent } from './auth/auth.component';
import { UserRecoveryComponent } from './auth/user-recovery/user-recovery.component';
import { UserRecoveryModalComponent } from './auth/user-recovery-modal/user-recovery-modal.component';
import { UserVerifyComponent } from './auth/user-verify/user-verify.component';
import { ValidationRulesModalComponent } from './auth/validation-rules-modal/validation-rules-modal.component';
import { RequestClarificationComponent } from './request/request-clarification/request-clarification.component';
import { RequestCpeFilterComponent } from './request/request-cpe/cpe-filter/cpe-filter.component';
import { RequestCpeComponent } from './request/request-cpe/request-cpe.component';
import { RequestCreateFormComponent } from './request/request-create/request-create-form/request-create-form.component';
import { RequestCreateComponent } from './request/request-create/request-create.component';
import { RequestDefaultComponent } from './request/request-default/request-default.component';
import { RequestDetailComponent } from './request/request-detail/request-detail.component';
import { RequestDetailOldComponent } from './request/request-detail-old/request-detail-old.component';
import { RequestFiltersComponent } from './request/request-filters/request-filters.component';
import { RequestHistoryComponent } from './request/request-history/request-history.component';
import { RequestListComponent } from './request/request-list/request-list.component';
import { RequestListOldComponent } from './request/request-list-old/request-list-old.component';
import { RequestListOrdComponent } from './request/request-list-ord/request-list-ord.component';
import { RequestModalComponent } from './request/request-modal/request-modal.component';
import { RequestTypeSidebarComponent } from './request/request-type-sidebar/request-type-sidebar.component';
import { RequestComponent } from './request/request.component';
import { RequestFormModule } from './request-form/request-form.module';
import { UserCreateEditComponent } from './user/user-create-edit/user-create-edit.component';
import { UserFiltersComponent } from './user/user-filters/user-filters.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { UserComponent } from './user/user.component';

import { environment } from 'environments/environment';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    Auth401Component,
    UserVerifyComponent,
    RequestComponent,
    RequestHistoryComponent,
    RequestDefaultComponent,
    RequestListOrdComponent,
    RequestCreateComponent,
    RequestListComponent,
    RequestTypeSidebarComponent,
    UserComponent,
    UserListComponent,
    UserCreateEditComponent,
    UserRecoveryModalComponent,
    UserRecoveryComponent,
    ValidationRulesModalComponent,
    RequestModalComponent,
    RequestDetailComponent,
    RequestCpeComponent,
    RequestCpeFilterComponent,
    RequestFiltersComponent,
    RequestCreateFormComponent,
    UserFiltersComponent,
    RequestClarificationComponent,
    RequestListOldComponent,
    RequestDetailOldComponent,
  ],
  imports: [
    NoopAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    NgxLoadingModule,
    NgPipesModule,
    ReactiveFormsModule,
    FormsModule,
    CoreModule.forRoot(),
    SharedModule,
    NgbModule,
    ScmModule,
    RequestFormModule,
    AuthModule.forRoot(environment),
    MicroservicesModule.forRoot(environment),
    RecaptchaModule,
    RecaptchaFormsModule,
    AuthSessionModule,
    Dsm34LoaderModule,
    DSM34DialogModule,
  ],
  providers: [
    RequestsConfigModule,
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'pt',
    },
    provideUnavailableFeaturesInitializer(),
    {
      provide: APP_INITIALIZER,
      useFactory: AutomationsTestsLoader,
      deps: [AutomationTestsService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AutomationTestsInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})
export class AppModule {}
